module.exports = __webpack_public_path__ + "img/IMG_2550-2.37123f5a.jpg";